// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner {
  width: 44px;
  height: 44px;
  animation: spinner-y0fdc1 2s infinite ease;
  transform-style: preserve-3d;
}

.spinner > div {
  background-color: rgba(246, 171, 232, 0.2);
  height: 100%;
  position: absolute;
  width: 100%;
  border: 2px solid #ffffff;
}

.spinner div:nth-of-type(1) {
  transform: translateZ(-22px) rotateY(180deg);
}

.spinner div:nth-of-type(2) {
  transform: rotateY(-270deg) translateX(50%);
  transform-origin: top right;
}

.spinner div:nth-of-type(3) {
  transform: rotateY(270deg) translateX(-50%);
  transform-origin: center left;
}

.spinner div:nth-of-type(4) {
  transform: rotateX(90deg) translateY(-50%);
  transform-origin: top center;
}

.spinner div:nth-of-type(5) {
  transform: rotateX(-90deg) translateY(50%);
  transform-origin: bottom center;
}

.spinner div:nth-of-type(6) {
  transform: translateZ(22px);
}

@keyframes spinner-y0fdc1 {
  0% {
    transform: rotate(45deg) rotateX(-25deg) rotateY(25deg);
  }
  50% {
    transform: rotate(45deg) rotateX(-385deg) rotateY(25deg);
  }
  100% {
    transform: rotate(45deg) rotateX(-385deg) rotateY(385deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/loader/loader.component.scss"],"names":[],"mappings":"AACA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAAJ;;AAGE;EACC,WAAA;EACA,YAAA;EACA,0CAAA;EACA,4BAAA;AAAH;;AAGE;EACC,0CAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;AAAH;;AAEE;EACC,4CAAA;AACH;;AACE;EACC,2CAAA;EACA,2BAAA;AAEH;;AAAE;EACC,2CAAA;EACA,6BAAA;AAGH;;AADE;EACC,0CAAA;EACA,4BAAA;AAIH;;AAFE;EACC,0CAAA;EACA,+BAAA;AAKH;;AAHE;EACC,2BAAA;AAMH;;AAJE;EACC;IACC,uDAAA;EAOF;EALC;IACC,wDAAA;EAOF;EALC;IACC,yDAAA;EAOF;AACF","sourcesContent":["// ------ CSS FOR Loader\r\n.loader-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    \r\n  }\r\n  .spinner {\r\n   width: 44px;\r\n   height: 44px;\r\n   animation: spinner-y0fdc1 2s infinite ease;\r\n   transform-style: preserve-3d;\r\n   \r\n  }\r\n  .spinner > div {\r\n   background-color: rgba(246, 171, 232, 0.2);\r\n   height: 100%;\r\n   position: absolute;\r\n   width: 100%;\r\n   border: 2px solid #ffffff;\r\n  }\r\n  .spinner div:nth-of-type(1) {\r\n   transform: translateZ(-22px) rotateY(180deg);\r\n  }\r\n  .spinner div:nth-of-type(2) {\r\n   transform: rotateY(-270deg) translateX(50%);\r\n   transform-origin: top right;\r\n  }\r\n  .spinner div:nth-of-type(3) {\r\n   transform: rotateY(270deg) translateX(-50%);\r\n   transform-origin: center left;\r\n  }\r\n  .spinner div:nth-of-type(4) {\r\n   transform: rotateX(90deg) translateY(-50%);\r\n   transform-origin: top center;\r\n  }\r\n  .spinner div:nth-of-type(5) {\r\n   transform: rotateX(-90deg) translateY(50%);\r\n   transform-origin: bottom center;\r\n  }\r\n  .spinner div:nth-of-type(6) {\r\n   transform: translateZ(22px);\r\n  }\r\n  @keyframes spinner-y0fdc1 {\r\n   0% {\r\n    transform: rotate(45deg) rotateX(-25deg) rotateY(25deg);\r\n   }\r\n   50% {\r\n    transform: rotate(45deg) rotateX(-385deg) rotateY(25deg);\r\n   }\r\n   100% {\r\n    transform: rotate(45deg) rotateX(-385deg) rotateY(385deg);\r\n   }\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
